//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import Card from '@/components/articles/Card.vue';
import CardMax from '@/components/articles/CardMax.vue';

export default BaseCmsBlock.extend({
  name: 'LastArticlesBlock',
  methods: {
    getClassBg: function (idx) {
    if (idx > 3) {
      idx = idx - Math.floor(idx / 4) * 4;
    }

    // if ((idx + 1) % 6 === 0) return "col-span-3";
    // if ((idx + 1) % 5 === 0) return "col-span-3";
    if ((idx + 1) % 4 === 0) return "bg-[#F4EFF4]";
    if ((idx + 1) % 3 === 0) return "bg-[#F4F2EA]";
    if ((idx + 1) % 2 === 0) return "bg-[#F3EFF1]";
    if ((idx + 1) % 1 === 0) return "bg-[#F1F6F8]";
  },
    getClassGrid: function(idx) {

      // console.log('this', this);

      if (idx > 5) {
        idx = idx - (Math.floor(idx / 6) * 6);
      }

      if ((idx + 1) % 6 === 0) return 'col-span-12 sm:col-span-6 2xl:col-span-3';
      if ((idx + 1) % 5 === 0) return 'col-span-12 sm:col-span-6 2xl:col-span-3';
      if ((idx + 1) % 4 === 0) return 'col-span-12 sm:col-span-12 2xl:col-span-6';
      if ((idx + 1) % 3 === 0) return 'col-span-12 sm:col-span-12 2xl:col-span-6';
      if ((idx + 1) % 2 === 0) return 'col-span-12 sm:col-span-6 2xl:col-span-3';
      if ((idx + 1) % 1 === 0) return 'col-span-12 sm:col-span-6 2xl:col-span-3';
    },

    onOpenArticle: function(aticle, location) {
      this.$router.push(location);
    }
  },
  computed:{
    title: function() {
      return this.values?.title || 'Новости'
    },
    onSetCategory(){},
  },
  components: {
    CardMax,
    Card,
  }
});
